import { useEffect, useState } from 'react';
import { RootState } from '@/store/index';
import { useSelector } from 'react-redux';
import { screenStaus } from "@/pages/watch/main/constants"
import WatchMobileTabMainView from "./view";
import { useAuthToken } from '@/hooks/useAppSelectors';

export default function WatchMobileTabMain(props: any) {
    const token = useAuthToken();

    const seriesDetails = useSelector((state: RootState) => state.seriesReducer.series);
    const videoDetails = useSelector((state: RootState) => state.videoReducer.video);
    const [currentScreenStatus, setCurrentScreenStatus] = useState<any>(screenStaus.seriesScreen)

    useEffect(() => {
        if (videoDetails) {
            setCurrentScreenStatus(screenStaus.videoScreen)
        }
    }, [videoDetails])

    useEffect(()=>{
        // if(isPublicVideo(props.currentVideoObj)){        
        if(!token){
            setCurrentScreenStatus(screenStaus.videoScreen)
        }
    },[props.currentVideoObj])

    return (
        <>
            <WatchMobileTabMainView
                seriesDetails={seriesDetails}
                isLoading={props.isLoading}
                currentScreenStatus={currentScreenStatus}
                updateCurrentVideoObj={props.updateCurrentVideoObj}
                playNextVideo={props.playNextVideo}
                currentVideoObj={props.currentVideoObj}
                seriesNotes={props.seriesNotes}
                isWelcomeSeries={props.isWelcomeSeries}
                seriesId={props.seriesId}
                isSubscribedSeries={props.isSubscribedSeries}
                isPGCourseSeries={props.isPGCourseSeries}
            />
        </>
    );
}

